// eslint-disable-next-line deprecated-imports/no-restricted-imports-deprecated
import { createFeature } from '@edreamsodigeo/frontend-core';
import React from 'react';
const NullComponent = () => null;
const createFakeABFeature = name => createFeature({
  name,
  variations: [NullComponent, NullComponent],
  LoadingComponent: NullComponent,
  version: 2
});
const createFakeABFeatureInputs = abs => abs.map(name => ({
  name,
  version: 2
}));
const FAKE_AB_TESTS_RESULTS_PAGE = 'fake-flights_results';
const FAKE_AB_TESTS_PASSENGERS_PAGE = 'fake-flights_passengers';
const FAKE_AB_TESTS_PRIME_PAGE = 'fake-flights_prime';
const FAKE_AB_TESTS_PAYMENT_PAGE = 'fake-flights_payment';
export const FakeABTestResultsPage = createFakeABFeature(FAKE_AB_TESTS_RESULTS_PAGE);
export const FakeABTestPassengersPage = createFakeABFeature(FAKE_AB_TESTS_PASSENGERS_PAGE);
export const FakeABTestPrimePage = createFakeABFeature(FAKE_AB_TESTS_PRIME_PAGE);
export const FakeABTestPaymentPage = createFakeABFeature(FAKE_AB_TESTS_PAYMENT_PAGE);
export const withFakeABTest = (Page, FakeABTest) => () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Page, null), /*#__PURE__*/React.createElement(FakeABTest, null));
export const fakeABTestFeatureInputs = createFakeABFeatureInputs([FAKE_AB_TESTS_RESULTS_PAGE, FAKE_AB_TESTS_PASSENGERS_PAGE, FAKE_AB_TESTS_PRIME_PAGE, FAKE_AB_TESTS_PAYMENT_PAGE]);